// src/App.js
import React, { useEffect, useState, lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { FaArrowUp } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/custom.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import { Analytics } from "@vercel/analytics/react";

// Lazy loading des pages pour améliorer les performances
const Home = lazy(() => import("./pages/Home"));
const EmploiPage = lazy(() => import("./pages/EmploiPage"));
const TarifsPage = lazy(() => import("./pages/TarifsPage"));
const AdhesionPage = lazy(() => import("./pages/AdhesionPage"));
const BenevolePage = lazy(() => import("./pages/BenevolePage"));

function App() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Initialiser AOS pour les animations
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: true,
      offset: 100,
    });

    // Réduire le temps de chargement initial pour améliorer les performances
    const timer = setTimeout(() => {
      setLoading(false);
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="logo-spinner">
          <img
            src="/logo.png"
            alt="Minon Association Logo"
            className="spinning-logo"
          />
        </div>
      </div>
    );
  }

  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Analytics />
          <Header />
          <main className="main-content">
            <Suspense fallback={
              <div className="loading-spinner" style={{
                minHeight: '60vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Chargement...</span>
                </div>
              </div>
            }>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/emploi" element={<EmploiPage />} />
                <Route path="/tarifs" element={<TarifsPage />} />
                <Route path="/adhesion" element={<AdhesionPage />} />
                <Route path="/benevole" element={<BenevolePage />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          {/* <ThemeToggle /> */}

          {showScrollTop && (
            <button
              className="scroll-to-top"
              onClick={scrollToTop}
              aria-label="Retour en haut"
            >
              <FaArrowUp />
            </button>
          )}
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
